// extracted by mini-css-extract-plugin
module.exports = {"title_wrapper":"uni_overview_scholarship_title_wrapper__Yr6nY"};